import { defineStore } from "pinia";
export const useGlobalStore = defineStore("global", {
  state: () => ({
    // Whether the authentication state has been initialized
    legalInfoModal: { visible: false },
    unreadNotificationsCount: null
    // Null -> not loaded yet
  }),
  actions: {
    showGtcModal() {
      this.showLegalInfoModal("gtc", "view.gtc.title");
    },
    showPrivacyPolicyModal() {
      this.showLegalInfoModal("privacy", "view.privacy_policy.title");
    },
    showLegalInfoModal(key, titleLangKey) {
      this.$patch({
        legalInfoModal: {
          visible: true,
          key,
          titleLangKey
        }
      });
    },
    setUnreadNotificationsCount(count) {
      this.unreadNotificationsCount = count;
      if (window.native_badge_update) {
        window.native_badge_update.postMessage(count.toString());
      }
    },
    async loadUnreadNotificationsCount() {
      const { $auth, $apiFetch } = useNuxtApp();
      let count = 0;
      if ($auth.id) {
        const { data } = await $apiFetch("/v1/notifications/count");
        count = data.count;
      }
      this.setUnreadNotificationsCount(count);
    }
  }
});
